module.exports = __webpack_public_path__ + "img/hapiple-group.02fe7e5.png";